"use client";

import Slider from "@/components/Slider";
import React, { useState } from "react";
import { cn } from "@/utils/utils";
import { Images } from "@/types/Product.type";
import Image from "@/components/ui/Image";
import SlideNextIcon from "@/components/icons/SlideNextIcon";
import SlidePrevIcon from "@/components/icons/SlidePrevIcon";
import ProductConstants from "@/common/constants/product";

import PopupDefault from "@/components/PopupDefault";
import ImageConstant from "@/common/constants/image";
import PopupV2 from "@/components/PopupV2";

interface ProductImagesProps {
	images: Images[];
	indexActive: number;
	onChangeImage: (index: number) => void;
}

const handleRenderBanner = (
	item: Images,
	index: number,
	onClick?: () => void
) => {
	return (
		<div
			key={index}
			className={cn(
				"min-h-[390px]  w-full flex items-center justify-center cursor-pointer"
			)}
			onClick={onClick}>
			<Image
				width={390}
				height={390}
				className="rounded h-auto mx-auto"
				src={item.url}
				alt="img"
				placeholder={"blur"}
				blurDataURL={ImageConstant.BlurDataURL}
				priority
				// layout="responsive"
			/>
		</div>
	);
};

const handleRenderBannerModal = (item: Images, index: number) => {
	return (
		<div
			key={index}
			className={cn(
				"min-h-[500px] min-w-[500px] flex items-center justify-center cursor-pointer"
			)}>
			<Image
				width={500}
				height={500}
				className="object-cover object-bottom rounded"
				src={item.url}
				alt="img"
				placeholder={"blur"}
				blurDataURL={ImageConstant.BlurDataURL}
			/>
		</div>
	);
};

function ProductImages({
	images,
	indexActive,
	onChangeImage,
}: ProductImagesProps) {
	const [open, setOpen] = useState(false);

	return (
		<div className="h-auto">
			<div className="h-[400px]">
				{images.length > 0 ? (
					<Slider
						dataSource={images}
						initialSlide={indexActive}
						isloading={false}
						speed={800}
						itemRender={(item, index) =>
							handleRenderBanner(item, index, () => {
								setOpen(true);
							})
						}
						navigation={false}
						onSlideChange={(e) => {
							onChangeImage(e.activeIndex);
						}}
						autoplay={false}
						slidesPerGroup={1}
						slidesPerView={1}
						responsive={{
							xxs: { slidesPerView: 1, spaceBetween: 0 },
							xs: { slidesPerView: 1, spaceBetween: 0 },
							sm: { slidesPerView: 1, spaceBetween: 0 },
							md: { slidesPerView: 1, spaceBetween: 0 },
							lg: { slidesPerView: 1, spaceBetween: 0 },
							xl: { slidesPerView: 1, spaceBetween: 0 },
						}}
					/>
				) : (
					<Image
						src=""
						width={ProductConstants.RESIZE_IMAGE_PRODUCT_DETAIL}
						height={ProductConstants.RESIZE_IMAGE_PRODUCT_DETAIL}
						alt="image"
						placeholder={"blur"}
						className="mx-auto"
						blurDataURL={ImageConstant.BlurDataURL}
					/>
				)}
			</div>
			<div className="mt-4 hidden md:block relative">
				<Slider
					dataSource={images}
					initialSlide={Math.floor(indexActive / 5) + 1}
					isloading={false}
					classWrapper="px-[44px]"
					itemRender={(item: Images, index) => {
						return (
							<div
								key={index}
								className={cn(
									"cursor-pointer flex items-center justify-center w-[45px] h-[45px] border border-transparent rounded-sm overflow-hidden",
									{
										"border-gray-500": indexActive === index,
									}
								)}
								onClick={() => {
									onChangeImage(index);
								}}>
								<Image
									width={ProductConstants.RESIZE_IMAGE_PRODUCT_DETAIL_MINI}
									height={ProductConstants.RESIZE_IMAGE_PRODUCT_DETAIL_MINI}
									className="mx-auto"
									src={item.url}
									alt="img"
									placeholder={"blur"}
									blurDataURL={ImageConstant.BlurDataURL}
								/>
							</div>
						);
					}}
					navigation={false}
					speed={800}
					autoplay={false}
					// slidesPerGroup={6}
					// slidesPerView={6}
					spaceBetween={8}
					loop={false}
					allowSlideNext={true}
					allowSlidePrev={true}
					allowTouchMove={true}
					centeredSlidesDesktop={false}
					centeredSlidesMobile={true}
					classButtonSlide="hidden md:block"
					isResponsive={false}
					responsive={{
						xxs: { slidesPerView: 1.8, spaceBetween: 0 },
						xs: { slidesPerView: 2, spaceBetween: 0 },
						sm: { slidesPerView: 2, spaceBetween: 0 },
						md: { slidesPerView: 3, spaceBetween: 0 },
						lg: { slidesPerView: 4, spaceBetween: 0 },
						xl: { slidesPerView: 5.8, spaceBetween: 0 },
					}}
				/>

				{images.length > 1 && (
					<>
						<button
							id="button_swiper_next"
							onClick={() => {
								if (indexActive < images.length - 1) {
									onChangeImage(indexActive + 1);
								}
							}}
							style={{
								width: 30,
								height: 30,
								borderRadius: 1000,
								display: "flex",

								justifyContent: "center",
								alignItems: "center",
								backgroundColor: "#fff",
								boxShadow: "0px 0px 10px 0px rgba(187, 187, 187, 0.25)",
								right: 0,
							}}
							disabled={indexActive === images.length - 1}
							className={`absolute -right-[20px] top-[50%] -translate-y-[50%] disabled:cursor-not-allowed disabled:opacity-50`}>
							<SlideNextIcon className="w-[18px] h-[18px] min-w-[18px]" />
						</button>
						<button
							id="button_swiper_prev"
							disabled={indexActive === 0}
							onClick={() => {
								if (indexActive > 0) {
									onChangeImage(indexActive - 1);
								}
							}}
							style={{
								width: 30,
								height: 30,
								borderRadius: 1000,
								display: "flex",
								left: 0,
								justifyContent: "center",
								alignItems: "center",
								backgroundColor: "#fff",
								boxShadow: "0px 0px 10px 0px rgba(187, 187, 187, 0.25)",
							}}
							className={` absolute -left-[20px] top-[50%] -translate-y-[50%] disabled:cursor-not-allowed disabled:opacity-50`}>
							<SlidePrevIcon className="w-[18px] h-[18px] min-w-[18px]" />
						</button>
					</>
				)}
			</div>

			<PopupV2 open={open} onOpenChange={() => setOpen(false)}>
				<Slider
					dataSource={images}
					styleButton_next={{
						right: 0,
					}}
					styleButton_prev={{
						left: 0,
					}}
					initialSlide={indexActive}
					isloading={false}
					speed={800}
					itemRender={handleRenderBannerModal}
					navigation={true}
					autoplay={false}
					slidesPerGroup={1}
					slidesPerView={1}
					classNameItemRender=" flex justify-center"
					responsive={{
						xxs: { slidesPerView: 1, spaceBetween: 0 },
						xs: { slidesPerView: 1, spaceBetween: 0 },
						sm: { slidesPerView: 1, spaceBetween: 0 },
						md: { slidesPerView: 1, spaceBetween: 0 },
						lg: { slidesPerView: 1, spaceBetween: 0 },
						xl: { slidesPerView: 1, spaceBetween: 0 },
					}}
				/>
			</PopupV2>
		</div>
	);
}

export default ProductImages;
